import React from 'react'

const CancelOrders = () => {
  return (
    <div>Please login to cancel successful orders</div>
  )
}

export default CancelOrders;